import styled from 'styled-components';

export const HeaderContainer = styled.header`
  height: 64px;
  background-color: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
`;

export const HeaderContent = styled.div`
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing[6]};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 0 ${({ theme }) => theme.spacing[4]};
  }
`;

export const HeaderLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    gap: ${({ theme }) => theme.spacing[2]};
  }
`;

export const QuickLinksContainer = styled.div`
  position: relative;
  margin-left: 16px;
`;

export const QuickLinksButton = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  font-weight: 600;
  color: ${({ theme, $isOpen }) => $isOpen ? theme.colors.primary : theme.colors.gray700};
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s;

  @media (max-width: 768px) {
    padding: 8px 4px;
    gap: 4px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray100};
    color: ${({ theme }) => theme.colors.primary};
  }

  svg {
    transition: transform 0.2s;
    transform: ${({ $isOpen }) => $isOpen ? 'rotate(180deg)' : 'rotate(0)'};
    color: ${({ theme, $isOpen }) => $isOpen ? theme.colors.primary : theme.colors.gray500};
  }
`;

export const QuickLinksText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    gap: ${({ theme }) => theme.spacing[2]};
  }
`;

export const UserMenuContainer = styled.div`
  position: relative;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.gray600};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  position: relative;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray100};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background-color: #EF4444;
  border-radius: 50%;
  border: 2px solid white;
`;

export const CurrencySelector = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.gray100};
  font-weight: 600;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.gray700};
  transition: all 0.2s;

  @media (max-width: 768px) {
    display: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray200};
  }

  span {
    font-size: 1.2rem;
  }
`;

export const ProfileButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid white;
  box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.gray200};
  padding: 0;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};

  img {
    @media (max-width: 768px) {
      height: 24px !important;
    }
  }
`;

export const LogoIcon = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
`;

export const LogoText = styled.span`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray900};
`;

export const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${({ theme }) => theme.colors.gray600};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${({ theme }) => theme.colors.gray900};
  }
`;
